<template>
  <div class="color-field">
    <ColorPicker :dialog="dialog" :cor="novaCor" @dialogClose="dialogClose" @setCor="setCor" />
    <div class="color-field__nome">{{ nome }}:</div>
    <div class="color-field__cor" :class="novaCor == '#FFFFFF' ? 'color-field__cor--outline' : ''" :style="{ backgroundColor: novaCor }"></div>
    <div>{{ novaCor }}</div>
    <v-btn text @click="dialogOpen">Selecionar cor</v-btn>
  </div>
</template>

<script>
import ColorPicker from './ColorPicker.vue'
export default {
  props: {
    cor: String,
    nome: String
  },
  components: {
    ColorPicker
  },
  data: () => ({
    novaCor: '#FFFFFF',
    dialog: false
  }),
  methods: {
    dialogClose() {
      this.dialog = false
    },
    setCor(cor) {
      this.novaCor = cor
      this.$emit("setCor", this.novaCor)
    },
    dialogOpen() {
      this.dialog = true
    }
  },
  watch: {
    cor() {
      this.novaCor = this.cor
    }
  }
};
</script>

<style scoped>
.color-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.color-field__nome {
  width: 180px;
}

.color-field__cor {
  width: 30px;
  height: 30px;
  border-radius: 18px;
}

.color-field__cor--outline {
  border: 1px solid gray;
}
</style>
